import { render, staticRenderFns } from "./refundInfo.vue?vue&type=template&id=81bd02b2&scoped=true"
import script from "./refundInfo.vue?vue&type=script&lang=js"
export * from "./refundInfo.vue?vue&type=script&lang=js"
import style0 from "./refundInfo.vue?vue&type=style&index=0&id=81bd02b2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bd02b2",
  null
  
)

export default component.exports